

const tickerMapping = {
    brkb: 'brk-b'
}


const indexToName = {
  "^N225": "Nikkei 225",
  "^FTSE": "FTSE 100",
  "^HSI": "Hang Seng",
  "^STI": "Straits Times",
  "^NSEI": "Nifty 50",
  "^AXJO": "ASX 200",
  "^GSPTSE": "TSX Composite",
  "^VIX": "CBOE Volatility Index",
  "^VVIX": "CBOE VVIX Index",
  "^VIX9D": "CBOE 9-Day Volatility Index",
  "^VIX3M": "CBOE 3-Month Volatility Index",
  "^VIX6M": "CBOE 6-Month Volatility Index",
  "^SKEW": "CBOE SKEW Index",
  "^VXN": "CBOE Nasdaq Volatility Index",
  "^IRX": "3-Month Treasury Bill",
  "^FVX": "5-Year Treasury Note",
  "^TNX": "10-Year Treasury Note",
  "^SP600": "S&P 600 Small Cap Index",
  "^SP400": "S&P 400 Mid Cap Index",
  "^GSPC": "S&P 500 Index",
  "^IXIC": "Nasdaq Composite Index",
  "^GSPE": "S&P 500 Energy Sector",
  "^SP500-45": "S&P Technology Sector"
};

const sectorLookup = {
    "energy": 'xle',
    "cyclicals": 'xly',
    "technology": 'xlk',
    "healthcare": 'xlv',
    "financials": 'xlf',
    "industrials": 'xli',
    "defensive": 'xlp',
    "utilities": 'xlu',
    "materials": 'xlb',
    "real estate": 'xlre',
    "communication": 'xlc'
};


const SectorAbbreviationMap = {
    "information technology": "Technology",
    "consumer discretionary": "Discretionary",
    "communication": "Communication",
    "health care": "Healthcare",
    "financials": "Finance",
    "consumer staples": "Staples",
    "energy": "Energy",
    "industrials": "Industrials",
    "utilities": "Utilities",
    "materials": "Materials",
    "real estate": "Real Estate",
    "cash and/or derivatives": "CASH",
    "consumer cyclical": "Cyclicals",
    "communication services": "Communication",
    "consumer defensive": "Denfensive"
};

// Function to shorten sector names
function shortenSector(sectorName) {
    // Ensure input is in lowercase
    const lowerCaseSector = sectorName.toLowerCase();

    // Return the corresponding abbreviation or 'other'
    return SectorAbbreviationMap[lowerCaseSector] || sectorName.length > 20 ? `${sectorName.slice(0, 18)}..` : sectorName;
}


// Unified sector lookup function
function getSectorCode(sectorName) {
    const lowerCaseSector = sectorName.toLowerCase();

    // First check if the sector abbreviation is present in the map
    const standardizedSector = SectorAbbreviationMap[lowerCaseSector] || lowerCaseSector;

    // Return the sector code from the sectorLookup
    return sectorLookup?.[standardizedSector?.toLowerCase()]
}



function getIndexName(symbol) {
    return indexToName[symbol?.toUpperCase?.()] || symbol;
}


function getSanitizedTicker(symbol){
    const formattedSymbol = symbol?.toLowerCase()
    return tickerMapping[formattedSymbol] || formattedSymbol;
}

export { shortenSector, getSectorCode, getIndexName, getSanitizedTicker };